import { CircularProgress, Grid } from "@mui/material";

export const CustomLoadingOverlay = () => (
	<Grid
		container
		justifyContent="center"
		alignItems="center"
		style={{ minHeight: "150px" }}
	>
		<CircularProgress size="3rem" />
	</Grid>
);
